import { render, staticRenderFns } from "./OutputBox.vue?vue&type=template&id=9d8a1dda&scoped=true"
import script from "./OutputBox.vue?vue&type=script&lang=ts"
export * from "./OutputBox.vue?vue&type=script&lang=ts"
import style0 from "./OutputBox.vue?vue&type=style&index=0&id=9d8a1dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8a1dda",
  null
  
)

export default component.exports